import { createApp } from 'vue/dist/vue.esm-bundler';
import { createRouter, createWebHistory } from 'vue-router'
import { createStore } from 'vuex'
import axios from 'axios'
import Login from './components/login.vue'
import Register from './components/register.vue'
import Forgot from './components/forgot.vue'
import p2papp from './components/p2papp.vue'
import appedit from './components/card/appedit.vue'
import nodeedit from './components/card/nodeedit.vue'
import EditMember from "./components/sdwannodeedit"
import device from './components/device.vue'
import sdwan from './components/sdwan.vue'
import profile from './components/profile.vue'
import errPage from './components/error.vue'
import agreementPage from './components/agreement.vue'
import install from './components/install.vue'
import App from './App.vue'
import auth from './auth.js'
import FaIcon from "./components/icons";
import VueI18n from './locale'
import { isValidString } from './utils';
import { compareVersions } from './utils';
import './utils';
export const ServerHost = ''
// export const ServerHost = 'http://localhost:10008'
// export const ServerHost = 'http://api.openp2p.cn:10008'
function requireAuth(to, from, next) {
  // window.debugLog("requireAuth")
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}
const routes = [
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { path: '/forgot', component: Forgot },
  { path: '/', component: Login, beforeEnter: requireAuth },
  { path: '/app/:nodeName', component: p2papp, beforeEnter: requireAuth },
  { path: '/appedit/:nodeName', component: appedit, beforeEnter: requireAuth },
  { path: '/nodeedit/:nodeName', component: nodeedit, beforeEnter: requireAuth },
  { path: '/sdwannodeedit/:index', name: 'EditMember', props: true, component: EditMember, beforeEnter: requireAuth },
  { path: '/device', component: device, beforeEnter: requireAuth },
  { path: '/sdwan', component: sdwan, beforeEnter: requireAuth },
  { path: '/profile', component: profile, beforeEnter: requireAuth },
  { path: '/error', component: errPage },
  { path: '/agreement', component: agreementPage },
  { path: '/install', component: install, beforeEnter: requireAuth },
]

const router = createRouter({
  history: createWebHistory(),
  routes, // `routes: routes` 的缩写
})

const store = createStore({
  state() {
    return {
      nodes: [],
      sdwan: {},
      apps: {},
      token: {},
      createApp: "",
      keyword: "",
      error: "",
    }
  },
  mutations: {
    setNodes(state, nodes) {
      state.nodes = nodes
    },
    setSdwan(state, sdwan) {
      state.sdwan = sdwan
    },
    setApps(state, apps) {
      state.apps = apps
    },
    setToken(state, token) {
      state.token = token
    },
    setCreateApp(state, createApp) {
      state.createApp = createApp
    },
    setKeyword(state, word) {
      state.keyword = word
    },
  }
})

async function initDataOnce() {
  const $t = this.$t
  window.debugLog("initDataOnce", this.$store.state.nodes)
  if (this.$store.state.nodes && this.$store.state.nodes.length > 0) {
    // 这里是状态为非空数组时的代码逻辑
  } else {
    window.debugLog("call /api/v1/devices")
    let res = await axios.get(this.$ServerHost + "/api/v1/devices")
    // window.debugLog('devices:', res)
    if (res && res.data.nodes) {
      let _clients = res.data.nodes
      let nodes = _clients.map((client) => { // TODO: save in map instead of array
        let {
          id,
          natType,
          bandwidth,
          ip,
          ipv6,
          hasIPv4,
          hasUPNPorNATPMP,
          lanip,
          mac,
          name,
          os,
          isActive,
          version,
          remark,
          removed,
          activetime,
          addtime,
          isUpdate,
        } = client
        // window.debugLog("got one device", client)
        return {
          id,
          natType,
          bandwidth,
          ip,
          ipv6,
          hasIPv4,
          hasUPNPorNATPMP,
          lanip,
          mac,
          name,
          remark,
          os,
          version,
          isActive,
          isUpdate,
          removed,
          activetime,
          addtime,
          latestVer: $t("latestVer") + ":" + res.data.latestVer,
        }
      })
      this.$store.commit("setNodes", nodes)
    }
  }
  if (this.$store.state.sdwan && this.$store.state.sdwan.Nodes) {
    // 这里是状态为非空数组时的代码逻辑
  } else {
    window.debugLog("call /api/v1/sdwans/")
    const response = await axios.get(this.$ServerHost + "/api/v1/sdwans/")
    window.debugLog("sdwan:", response.data)
    this.$store.commit("setSdwan", response.data)
    this.$store.state.sdwan.Nodes = response.data.Nodes || []
    this.$store.state.sdwan.centralNode = response.data.centralNode || ""
  }
}

const app = createApp(App)
app.use(router)
app.use(store)
app.config.globalProperties.$ServerHost = ServerHost
app.config.globalProperties.$nodes = {}
app.use(FaIcon)
// app.use(FaModal)
app.use(VueI18n)
app.mount('#app')
app.config.globalProperties.$isValidString = isValidString;
app.config.globalProperties.$compareVersions = compareVersions;
app.config.globalProperties.$initDataOnce = initDataOnce;
axios.defaults.headers.common['Authorization'] = localStorage.token;
// window.debugLog('main:',axios.defaults.headers.common['Authorization'])

var rspInterc = axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    window.debugLog('axios error:', error)
    // For node
    if (typeof XMLHttpRequest === "undefined") {
      if (error.response) return Promise.reject(error.response.data);
      return Promise.reject(error);
    }

    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
          store.commit('error', 'tokenExpired')
          window.location.href = '/error'

          break
        case 404:
          return Promise.reject(error.detail);
        default:
          break
      }
    }
    return Promise.reject(error); // 返回接口返回的错误信息
  }
);
axios.interceptors.response.use(rspInterc)
// load storage token
if (localStorage.token) {
  store.commit('setToken', JSON.parse(Buffer.from(localStorage.token.split('.')[1], 'base64')))
}
store.commit('setCreateApp', localStorage.createApp)

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1,                 //月份 
    "d+": this.getDate(),                    //日 
    "h+": this.getHours(),                   //小时 
    "m+": this.getMinutes(),                 //分 
    "s+": this.getSeconds(),                 //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds()             //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}
